import { render, staticRenderFns } from "./LogicalNumberList.vue?vue&type=template&id=b31b46a2"
import script from "./LogicalNumberList.vue?vue&type=script&lang=js"
export * from "./LogicalNumberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports